<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div class="d-flex p-4" style="background-color: #F8F8F8;border-radius: 4px;">
      <div :id="`waffle-switch-container_${question?.name}`" v-bind="$attrs" class="d-flex align-items-center waffle-switch-container" :class="{error}">
        <span
            class="waffle-switch-toggle-wrapper me-4"
            :id="`waffle-switch-toggle-wrapper_${question?.name}`"
            role="checkbox"
            :disabled="disabled"
            :aria-checked="value"
            tabindex="0"
            @click="$emit('user-interaction');toggle()"
            @blur="$emit('user-interaction')"
            @keydown.space.prevent="toggle"
        >
      <span
          class="waffle-switch-toggle-background"
          :id="`waffle-switch-toggle-background_${question?.name}`"
          :class="backgroundStyles"
      />
      <span
          class="waffle-switch-toggle-indicator"
          :id="`waffle-switch-toggle-indicator_${question?.name}`"
          :style="indicatorStyles"
      />
    </span>
      </div>
      <div class="d-flex flex-column">
        <div :class="`fw-bold ${question?.section || isAccordion ? 'fs-16 fs-lg-18':'fs-18 fs-lg-20'}`">
          <span class="prompt-label" v-html="question?.prompt"/> - {{value ? question?.options?.[1]?.value : question?.options?.[0]?.value}} <span  class="question-help-tooltip" v-html="question?.tooltip"/>
        </div>
        <div>
          <span style="font-size: 14px">{{question?.helptext}}</span>
        </div>
      </div>
    </div>
    <slot name="helptext" :isConfirm="false" :isError="error"
          :confirmCb="() =>{ $emit('user-interaction');$emit('confirm')}"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="value ? question?.options[1]?.value : question?.options[0]?.value"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>

<script>
import ReadOnly from "@/components/themeable-components/ReadOnly.vue";

export default {
  components: {ReadOnly},
  props: ['question','forcePromptPlaceholder','disabled','isAccordion'],
  emits: ["update:modelValue", "field-error", 'user-interaction'],
  data() {
    return {
      value: false,
      error: '',
    }
  },
  mounted() {
    if (this.question.options.length > 2) {
      console.warn('Field configuration for switch input has more than 2 options, only using the first  options')
    }

    if (this.question?.value) {
      if (this.question?.options[0]?.value === this.question?.value) {
        this.value = false;
      } else {
        this.value = true
      }
    }

    if (this.question?.error) {
      this.$emit('field-error', true)
      this.error = this.question.error;
    }
  },
  watch: {
    question: {
      handler: function (newVal) {
        if (newVal.options.length > 2) {
          console.warn('Field configuration for switch input has more than 2 options, only using the first  options')
        }
        const valFromOptionIndex = newVal.options.findIndex(el => el.value === newVal?.value) > 0
        if (valFromOptionIndex !== this.value && newVal?.value) {
          if (newVal?.options[0]?.value === newVal?.value) {
            this.value = false;
          } else {
            this.value = true
          }
          this.$emit('update:modelValue', this.value ? this.question?.options[1]?.value : this.question?.options[0]?.value);
        }

        if (newVal?.error) {
          this.$emit('field-error', true)
          this.error = newVal.error;
        }
      },
      deep: true
    }
  },
  computed: {
    backgroundStyles() {
      return {
        'waffle-switch-mid': this.value,
        'waffle-switch-lighter': !this.value
      };
    },
    indicatorStyles() {
      return {transform: this.value ? 'translateX(calc(27px))' : 'translateX(0)'};
    }
  },
  methods: {
    toggle() {
      this.value = !this.value
      this.$emit('field-error', false)
      this.$emit('update:modelValue', this.value ? this.question?.options[1]?.value : this.question?.options[0]?.value);
    }
  }
};
</script>
